import { Component, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { ProvinceDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { setTitle } from "../../title/state/title.actions";
import { resetCurrentProvince, setAdmissionDate, setSelectedProvince } from "../../transaction-info/state/transaction-info.actions";
import { loadProvinces, resetProvince } from "../state/province.actions";
import { getProvinceList } from "../state/province.selectors";

@Component({
    selector: "app-province",
    templateUrl: "./province.component.html",
    styleUrls: ["./province.component.scss"],
    standalone: false
})
export class ProvinceComponent implements OnInit {
	public provinces$: Observable<ProvinceDto[]> = this.store.pipe(select(getProvinceList)).pipe(filterNullOrUndefined());
	public properyToDisplay = "provinceNameEN";
	
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>) {
		this.subs.push(getState(this.store).subscribe(state=>{
			this.properyToDisplay = "provinceName" + state.transactionInfo.selectedLanguage.languageCode;
		}));
	}

	ngOnInit(): void {
		//load questionnaire
		this.store.dispatch(loadProvinces());

		this.store.dispatch(
			setTitle({
				data: "TITLE_SELECT_PROVINCE",
				data2: "TITLE_SELECT_PROVINCE_INFO",
			})
		);
	}

	onClickRetour() {
		this.store.dispatch(resetProvince());
		this.store.dispatch(resetCurrentProvince());
		this.store.dispatch(setAdmissionDate({ data: undefined }));
	}

	public onClickProvince(province: ProvinceDto) {
		this.store.dispatch(setSelectedProvince({ data: province }));
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
}
